exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".quote-for h3{background-color:#4b4b4b;border-radius:6px;font-size:1.5rem;font-weight:300;color:#fff;padding:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/QuoteFor/QuoteFor.scss
// module id = 7651
// module chunks = 13